/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { sandboxRunCommand } from "../../funcs/sandboxRunCommand.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.RunCommandRequest$inboundSchema,
};

export const tool$sandboxRunCommand: ToolDefinition<typeof args> = {
  name: "sandbox-run-command",
  description: `Run Command

Run a command in the session workspace and return stdout, stderr, exit code, and changed files.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await sandboxRunCommand(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
